import React, { useContext, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import "./Shop.css";
import {
  Category,
  CategoryProduct,
  Products,
  SubCategory,
} from "../../utils/apis/Product/Product";
import { useEffect } from "react";
import Verticle_Categories from "../Near-me/Scan-mart-store/verticle_categories/Verticle_Categories";
import "./Shop.css";
import Top_Filter_Div from "./top_filter_div/Top_Filter_Div";
import { Tab } from "react-bootstrap";
import Product_Info_Card from "../Common-Component/product_info_card/Product_Info_Card";
import Product_Info_Card_2 from "../Common-Component/product_info_card_2/Product_Info_Card_2";
import Product_Info_List_View from "./product_info_list_view/Product_Info_List_View";
import { Context } from "../../utils/context";
import { useLocation } from "react-router-dom";
import { getData } from "../../utils/api";
import { getallBrand } from "../../utils/apis/master/Master";

const Shop_Subcategory = () => {
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
 
   const { IMG_URL, shimmerLoader, setShimmerLoader,currentLocation } = useContext(Context);
  const category_id = queryParams.get("category_id");
  const user_id = queryParams.get("user_id");
  const category_image = queryParams.get("category_image");
  const selectedId = queryParams.get("brand_id")
    ? Number(queryParams.get("brand_id"))
    : null;

  const getCategory = async () => {
    const res = await getallBrand(user_id);

    if (res?.success) {
      setCategory(res?.data);
    }
  };
  const [selectId, setSelectId] = useState(selectedId);

  const [selectedOption, setSelectedOption] = useState("");
  const [products, setProducts] = useState([]);
  const AllProduct = async (brand_id) => {
      const city =
      currentLocation?.formatted_address ||currentLocation?.city ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";
    const allproduct = await Products(
      "",
      "",
      selectedOption || "",
      user_id,
      brand_id || "",
      "",
      city
    );
    if (allproduct?.success) {
      setProducts(allproduct?.data?.data);
    }
  };

  

  useEffect(() => {
    AllProduct(selectId);
  }, [selectId, selectedOption,currentLocation]);

  useEffect(() => {
    getCategory(category_id);
  }, [category_id]);

 

  return (
    <section className="Shop near_mart_store">
      <div className="container">
        <Tab.Container id="left-tabs-example" defaultActiveKey="Grid">
          <Top_Filter_Div
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />

          <div className="all_content_holder">
            <div className="left_side">
              <Verticle_Categories
                category_image={category_image}
                category={category}
                onClick={AllProduct}
                setSelectId={setSelectId}
                selectId={selectId}
              />
            </div>

            <div className="right_side_div">
              <Tab.Content>
                <Tab.Pane eventKey="Grid">
                  <div className="row">
                    {loading ? (
                      //  show spinner while loading
                      <div className="spinner-container text-center my-5">
                        <Spinner
                          animation="border"
                          style={{ color: "#235da5" }}
                          variant="primary"
                        />
                      </div>
                    ) : products?.length > 0 ? (
                      products?.map((product) => {
                        return (
                          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-5 custom_col">
                            <Product_Info_Card_2
                              product={product}
                              showQty
                              image={IMG_URL + product?.image1}
                              product_id={
                                product?.product_variants?.[0]?.product_id
                              }
                              variant_id={product?.product_variants?.[0]?.id}
                              prodname={product?.name}
                              descn={product?.product?.short_description}
                              selling_price={
                                product?.product_variants[0]?.s_price
                              }
                              mrp={product?.product_variants[0]?.mrp}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <div className="noprodiv">
                        <p>No Product Available</p>
                      </div>
                    )}
                  </div>
                  {/* 
                  <div className="shop_banner_holder">
                    <Shop_Banner />
                  </div> */}
                </Tab.Pane>
                <Tab.Pane eventKey="List">
                  {loading ? (
                    //  show spinner while loading
                    <div className="spinner-container text-center my-5">
                      <Spinner
                        animation="border"
                        style={{ color: "#235da5" }}
                      />
                    </div>
                  ) : products?.length > 0 ? (
                    products.map((product, index) => (
                      <Product_Info_List_View
                        key={index}
                        product={product}
                        showQty
                        image={IMG_URL + product?.image1}
                        product_id={product?.product_variants?.[0]?.product_id}
                        variant_id={product?.product_variants?.[0]?.id}
                        prodname={product?.name}
                        descn={product?.product?.short_description}
                        selling_price={product?.product_variants[0]?.s_price}
                        mrp={product?.product_variants[0]?.mrp}
                      />
                    ))
                  ) : (
                    <div className="noprodiv">
                      <p>No Product Available</p>
                    </div>
                  )}
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Shop_Subcategory;
